import * as types from '../constants';

const initialState = {
  buildingListTotal: 0,
  buildingListItems: [],
  currentPageNumber: 1,
  paginationItem: {
    offset: 0,
    limit: 10,
  },
  filterItem: {
    name: '',
  },
};

const BuildingListReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.INIT_BUILDING_LIST_STATE:
      return {
        ...state,
        buildingListTotal: 0,
        buildingListItems: [],
        currentPageNumber: 1,
        paginationItem: {
          offset: 0,
          limit: 10,
        },
        filterItem: {
          name: '',
        },
      };
    case types.SET_BUILDING_LIST:
      return {
        ...state,
        buildingListTotal: action.payload.total,
        buildingListItems: action.payload.items,
      };
    case types.SET_BUILDING_LIST_CURRENT_PAGE_NUMBER:
      return {
        ...state,
        currentPageNumber: action.payload,
      };
    case types.SET_BUILDING_PAGINATION_ITEM:
      return {
        ...state,
        paginationItem: action.payload,
      };
    case types.SET_BUILDING_FILTER_ITEM:
      return {
        ...state,
        filterItem: action.payload,
      };
    default:
      return state;
  }
};

export default BuildingListReducer;